 const ACCEPT_CONFIG = {
    image: ['.gif', '.jpg', '.jpeg', '.png', '.bmp', '.webp'],
    audio: ['.mp3', '.wav', '.wma', '.ogg', '.aac', '.flac'],
    document: ['.doc', '.txt', '.docx', '.pages', '.epub', '.pdf', '.numbers', '.csv', '.xls', '.xlsx', '.keynote', '.ppt', '.pptx','.zip','.exe','.apk','.rar','.iso','.torrent','.wps'],
    getAll(){
        return [...this.image,...this.document,...this.audio]
    },
};

export default ACCEPT_CONFIG